export default class LoadMore {

    constructor() {
        this.settings = {
            $postsList : $(".js-posts-list")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$postsList != null) {

            let postsList = this.settings.$postsList;
            let nrLoadMore = $('#js-nr-posts-load-more').val();
            let loadMoreBtn = $(".js-load-more");

            function postTypeList() {
                $('.js-post-single').removeClass('hidden');

                postsList.find('.js-post-single').each(function (index) {

                    // Hide posts
                    if (index >= nrLoadMore) {
                        $(this).addClass('hidden');
                    }
                });
            }

            postTypeList();

            function updateShowingNr() {
                let allPostsNr = $('.js-posts-list .js-post-single').length;
                let hiddenPostsNr = $('.js-posts-list .js-post-single.hidden').length;
                let showingNr = allPostsNr - hiddenPostsNr;

                $('.js-current-nr').text(showingNr);
            }

            updateShowingNr();

            if (postsList.find('.js-post-single.hidden').length === 0) {
                loadMoreBtn.removeClass('btn');
                loadMoreBtn.addClass('hidden');
            }

            loadMoreBtn.on('click', function () {

                let morePosts = postsList.find('.js-post-single.hidden');
                let counter = 0;


                morePosts.each(function () {

                    // Show more posts
                    if (counter >= nrLoadMore) {
                        return false;
                    }

                    counter++;

                    $(this).removeClass('hidden');
                });

                if (postsList.find('.js-post-single.hidden').length === 0) {
                    $(this).removeClass('btn');
                    $(this).addClass('hidden');
                }

                updateShowingNr();
            });

        }

    }
};

new LoadMore();